<div class="preview-card">
  <div class="text-start display-list px-3 col-12">
    <p>{{ group?.fieldGroupName }}</p>

    <ng-container
      *ngFor="
        let field of group?.fieldGroup;
        let i = index;
        trackBy: trackByFn
      ">
      <div *ngIf="field" [style.order]="field?.order">
        <ng-container
          *ngTemplateOutlet="
            fieldItemDataValues;
            context: { fieldItemData: field, content: content, index: i }
          ">
        </ng-container>
      </div>
    </ng-container>

    <div
      [style.order]="fieldArray?.order"
      class="d-flex flex-column"
      *ngFor="
        let fieldArray of group?.fieldArray;
        let i = index;
        trackBy: trackByFn
      ">
      <ng-container *ngIf="fieldArray?.arrayItems">
        <ng-container *ngFor="let arrayItem of fieldArray?.arrayItems">
          <ng-container *ngFor="let fieldGroupItem of arrayItem.formGroup">
            <div [style.order]="fieldGroupItem?.order">
              <ng-container
                *ngTemplateOutlet="
                  nestedBlock;
                  context: {
                    fieldGroupNameData: fieldGroupItem
                  }
                ">
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngFor="let fieldGroupItem of arrayItem.fieldGroup">
            <div [style.order]="fieldGroupItem?.order">
              <ng-container
                *ngTemplateOutlet="
                  fieldItemDataValues;
                  context: { fieldItemData: fieldGroupItem }
                ">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #content let-modal let-content>
  <div class="modal-body">
    <div class="modal-header-preview">
      <h1 class="fw-normal">
        <i class="fa fa-file-text"></i> {{ selectedAttachment?.fileName }}
      </h1>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div *ngIf="!this.filePath" class="d-flex justify-content-center mt-5">
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <ng-container
      *ngIf="
        selectedAttachment?.fileType === 'application/pdf' && base64Data;
        else imagePreview
      ">
      <pdf-viewer
        *ngIf="base64Data"
        [src]="base64Data"
        [render-text]="true"
        [original-size]="true"
        style="width: 100%; height: 80vh; margin-top: 15px"></pdf-viewer>
    </ng-container>
  </div>
</ng-template>

<ng-template #imagePreview>
  <img
    *ngIf="this.filePath"
    [src]="this.filePath"
    alt="Image preview"
    class="w-100 h-100 mt-3" />
</ng-template>

<ng-template
  let-fieldItemData="fieldItemData"
  let-content="content"
  let-index="index"
  #fieldItemDataValues>
  <ng-container
    *ngIf="
      fieldItemData?.fieldValue &&
      fieldItemData?.fieldType !== 'customfileupload' &&
      fieldItemData?.fieldType !== 'externalfileupload' &&
      fieldItemData?.fieldType !== 'custominternalfileupload'
    ">
    <ng-container
      *ngIf="multiLineValueFieldTypes.includes(fieldItemData.fieldType)">
      <div *ngFor="let value of getMultiLineValues(fieldItemData)">
        <span class="field-name">{{ value?.label }}</span>
        <p class="field-value">
          {{ value.key }}
        </p>
      </div>
    </ng-container>
    <div *ngIf="!multiLineValueFieldTypes.includes(fieldItemData.fieldType)">
      <span class="field-name">{{ fieldItemData?.fieldLabel }}</span>

      <p class="field-value">
        <ng-container
          *ngIf="!complexFieldTypes.includes(fieldItemData.fieldType)">
          {{ getSingleLineValue(fieldItemData) }}
        </ng-container>

        <ng-container
          *ngIf="complexFieldTypes.includes(fieldItemData.fieldType)">
          <!-- Multi-Select Data Fetch with Dynamic Metadata -->
          <ng-container
            *ngIf="fieldItemData.fieldType === 'custommultiselectdatafetch'">
            <!-- Dynamic Summary Section -->
            <div
              class="row mb-3"
              *ngIf="
                fieldItemData?.additionalData?.previewMetadataConfig?.length > 0
              ">
              <ng-container
                *ngFor="
                  let config of fieldItemData?.additionalData
                    ?.previewMetadataConfig
                ">
                <div class="col-md-6 mb-2">
                  <p class="group-text dark-grey-color tt_norms400 m-0">
                    {{ config.label | translate }}
                  </p>
                  <p class="group-value tt_norms500 m-0">
                    {{ config.prefix | translate }}
                    {{ config.formatter === 'number' || config.formatter === 'currency' ? (fieldItemData?.additionalData?.metadata?.[config.key] | number) : fieldItemData?.additionalData?.metadata?.[config.key]}}
                    {{ config.suffix | translate }}
                  </p>
                </div>
              </ng-container>
            </div>

            <!-- Data Table -->
            <div class="mt-3">
              <irembogov-data-table
                [columns]="fieldItemData?.additionalData?.columns"
                [searchable]="false"
                [selectable]="false"
                [data]="fieldItemData?.fieldValue"
                [minimalPagination]="true">
              </irembogov-data-table>
            </div>
          </ng-container>

          <!-- Regular Data Tables -->
          <irembogov-data-table
            *ngIf="fieldItemData.fieldType === 'customdatatable'"
            [columns]="fieldItemData?.additionalData"
            [searchable]="false"
            [selectable]="false"
            [data]="fieldItemData?.fieldValue"
            [minimalPagination]="true">
          </irembogov-data-table>

          <irembogov-editable-table
            *ngIf="fieldItemData.fieldType === 'customeditabletable'"
            [rows]="fieldItemData?.additionalData?.rows"
            [columns]="fieldItemData?.additionalData?.columns"
            [showRowLabels]="
              fieldItemData?.additionalData?.showRowLabels ?? true
            "
            [rowColumnTitle]="
              fieldItemData?.additionalData?.rowColumnTitle || ''
            "
            [tableData]="fieldItemData?.fieldValue"
            [readOnly]="true">
          </irembogov-editable-table>
        </ng-container>
      </p>
    </div>
  </ng-container>
  <div
    class="custom-uploads row py-3 px-2 mx-0 rounded-3 mb-2"
    *ngIf="
      fieldItemData?.fieldType === 'customfileupload' ||
      fieldItemData?.fieldType === 'custominternalfileupload'
    ">
    <div
      class="col-1 float-start d-flex justify-content-center align-items-center text-center">
      <img src="../../assets/images/file-icon.svg" alt="" />
    </div>
    <div class="col-11 row d-flex flex-grow-1">
      <div class="d-flex justify-content-between pt-2">
        <div>
          <div
            class="text-start text-dark fs-6 fw-medium text-capitalize text-break">
            {{ fieldItemData?.fieldLabel }}
          </div>
          <div
            class="text-start text-dark fs-8 fw-medium text-capitalize text-break">
            {{ getAttachmentValue(fieldItemData?.fieldValue).fileName }}
          </div>
        </div>
        <div
          class="text-end bg-primary rounded-circle p-1 d-flex justify-content-center align-items-center checker">
          <i class="fa-solid fa-check text-white checker-icon"></i>
        </div>
      </div>
      <div class="text-start text-dark fs-6 fw-normal m-0">
        {{ getAttachmentValue(fieldItemData?.fieldValue).fileSize | fileSize }}
      </div>
    </div>
  </div>
  <div
    class="custom-uploads row py-3 px-2 mx-0 rounded-3 mb-2"
    *ngIf="fieldItemData?.fieldType === 'externalfileupload'">
    <div
      class="col-1 float-start d-flex justify-content-center align-items-center text-center"
      [style.cursor]="
        getExternalAttachmentDetails(fieldItemData?.fieldValue).url
          ? 'pointer'
          : 'default'
      "
      (click)="openExternalFileUrl(fieldItemData?.fieldValue)">
      <img src="../../assets/images/file-icon.svg" alt="external file" />
    </div>
    <div class="col-11 row d-flex flex-grow-1">
      <div class="d-flex justify-content-between pt-2">
        <div>
          <div
            class="text-start text-dark fs-6 fw-medium text-capitalize text-break">
            {{ fieldItemData?.fieldLabel }}
          </div>
          <div
            class="text-start text-dark fs-6 fw-medium text-break"
            style="
              word-break: break-word;
              white-space: normal;
              overflow-wrap: anywhere;
              line-height: 1.4;
              max-width: 100%;
            ">
            {{
              getExternalAttachmentDetails(fieldItemData?.fieldValue)
                .fileName ||
                getExternalAttachmentFileName(fieldItemData?.fieldValue) ||
                'External File'
            }}
          </div>
          <div class="text-start text-dark fs-6 fw-normal m-0">
            {{
              getExternalAttachmentDetails(fieldItemData?.fieldValue).fileSize
            }}
            •
            {{
              getExternalAttachmentDetails(fieldItemData?.fieldValue).fileType
            }}
          </div>
          <div
            *ngIf="getExternalAttachmentDetails(fieldItemData?.fieldValue).url"
            class="text-start text-primary fs-6 fw-normal mt-1"
            style="font-size: 0.75rem !important; word-break: break-all">
            {{ 'URL' | translate }}:
            {{ getExternalAttachmentDetails(fieldItemData?.fieldValue).url }}
          </div>
        </div>
        <div
          class="text-end bg-primary rounded-circle p-1 d-flex justify-content-center align-items-center checker">
          <i class="fa-solid fa-check text-white checker-icon"></i>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-fieldGroupNameData="fieldGroupNameData" #nestedBlock>
  <div class="my-3">
    <irembogov-application-form-field-card
      [group]="fieldGroupNameData"
      [applicationId]="applicationId"
      [baseUrl]="baseUrl"
      [applicationPath]="
        applicationPath
      "></irembogov-application-form-field-card>
  </div>
</ng-template>
